export default {
    root: {},
};
